export default {
  login: {
    title: 'Ins·代理商平台',
    username: '用户名',
    password: '密码',
    login: '登录',
    welcomeBack: '欢迎回来',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    networkError: '网络错误，请稍后重试',
    error: {
      username_required: '请输入用户名',
      password_required: '请输入密码',
      login_success: '登录成功',
      login_failed: '登录失败'
    }
  },
  common: {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    create: '创建',
    search: '搜索',
    reset: '重置',
    loading: '加载中',
    success: '成功',
    error: '错误',
    warning: '警告',
    info: '信息',
    tip: '提示',
    appName: '代理商管理系统',
    none: '无',
    copy: '复制',
    copySuccess: '复制成功',
    copyFailed: '复制失败'
  },
  header: {
    balance: '账户余额',
    recharge: '充值',
    logout: '退出登录',
    profile: '个人信息',
    welcome: '欢迎'
  },
  menu: {
    dashboard: '仪表盘',
    account: '我的账户',
    billing: '计费记录',
    proxy: '代理管理',
    staticproxy: '静态住宅代理',
    users: '用户管理',
    resellerManagement: '代理商管理',
    resellerList: '代理商列表',
    resellerAnalytics: '统计分析'
  },
  dashboard: {
    title: '仪表盘',
    totalBalance: '总余额',
    todayIncome: '今日收入',
    monthlyIncome: '本月收入',
    yearlyIncome: '年度收入',
    recentTransactions: '最近交易',
    statistics: '统计数据'
  },
  account: {
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    notifyUrl: '回调地址',
    copyNotifyUrl: '复制回调地址',
    resetKey: '重置密钥',
    resetWarning: '重置 API 密钥将使现有密钥失效，您确定要继续吗？',
    resetPassword: '重置密码',
    currentBalance: '当前余额',
    rechargeAmount: '充值金额',
    paymentMethod: '支付方式',
    alipay: '支付宝',
    wechat: '微信',
    suggestedAmounts: {
        ten: '¥10',
        fifty: '¥50',
        hundred: '¥100',
        twoHundred: '¥200',
        fiveHundred: '¥500',
        thousand: '¥1000'
    },
    error: {
      recharge_amount_required: '请输入充值金额',
      recharge_amount_invalid: '充值金额必须大于0',
      payment_method_required: '请选择支付方式',
      api_key_required: '请输入API密钥',
      copy: '复制失败',
      currentRequired: '请输入当前密码',
      newRequired: '请输入新密码',
      confirmRequired: '请输入确认密码',
      passwordLength: '密码长度至少6位',
      passwordMismatch: '两次输入的密码不一致'
    },
    success: {
      copy: '复制成功'
    },
    passwordFailed: '密码错误，请重新输入',
    modifyPassword: '修改登录密码',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    confirmChange: '确认修改',
    recharge: '充值',
    remainingTime: '剩余时间',
    scanQRCode: '请使用手机扫描二维码完成支付',
    paymentAmount: '支付金额'
  },
  billing: {
    title: '账单管理',
    orderNo: '订单编号',
    amount: '金额',
    status: '状态',
    createTime: '创建时间',
    paymentMethod: '支付方式',
    // 统计卡片
    monthlyConsume: '本月消费',
    monthlyRecharge: '本月充值',
    // 搜索表单
    transactionType: '交易类型',
    orderType: '订单类型',
    transactionTime: '交易时间',
    startDate: '开始日期',
    endDate: '结束日期',
    all: '全部',
    consume: '消费',
    refund: '退款',
    recharge: '充值',
    staticProxy: '静态代理订单',
    ipRenewal: 'IP续期',
    rechargeOrder: '充值订单',
    search: '搜索',
    reset: '重置',
    export: '导出',
    // 表格列
    orderNumber: '订单号',
    transactionTypeLabel: '交易类型',
    changeAmount: '变动金额',
    beforeBalance: '变动前金额',
    afterBalance: '变动后金额',
    orderTypeLabel: '订单类型',
    transactionDate: '交易日期',
    // 交易详情弹窗
    transactionDetail: '交易详情',
    remark: '备注',
    noRemark: '无',
    // 消息提示
    fetchTransactionsFailed: '获取交易记录失败',
    fetchStatsFailed: '获取月度统计失败',
    exportPreparing: '正在准备导出文件...',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    loadConditionsFailed: '加载搜索条件失败',
    // 文件名和错误消息
    transactionRecords: '交易记录',
    exportTransactionsFailed: '导出交易记录失败',
    exportFailedPrefix: '导出失败',
    unknownError: '未知错误',
    pleaseSelectRecords: '请选择要导出的记录'
   },
   proxy: {
    title: '代理管理',
    proxyList: '代理列表',
    createProxy: '创建代理',
    editProxy: '编辑代理',
    proxyDetail: '代理详情',
    // 表格列
    id: 'ID',
    ip: 'IP',
    oldIp: '旧IP',
    port: '端口号',
    location: 'IP归属地',
    orderNo: '订单号',
    days: '天数',
    traffic: '流量',
    totalTraffic: '总流量',
    usedTraffic: '已使用流量',
    expirationTime: '过期日期',
    tag: '标签',
    createTime: '下单时间',
    operations: '操作',
    renewalTime: '续期时间',
    renewalResult: '续期结果',
    reason: '原因',
    // 状态
    enableStatus: '启用状态',
    onlineStatus: '在线状态',
    enabled: '启用',
    disabled: '禁用',
    online: '在线',
    offline: '离线',
    success: '成功',
    failed: '失败',
    // Actions
    copyProxy: '复制代理',
    viewDetails: '查看详情',
    details: '详情',
    renewal: '续期',
    // 标签页
    purchasedIpList: '已购IP列表',
    renewalRecord: '续期记录',
    // 流量相关
     unlimitedTraffic: '无限流量',
     // 图标说明
     iconLegend: '图标说明'
   },
  breadcrumb: {
    dashboard: '仪表盘',
    account: '我的账户',
    billing: '计费',
    proxy: '代理管理',
    staticproxy: '静态住宅代理',
    users: '用户管理',
    resellerManagement: '代理商管理',
    resellerlist: '代理商列表',
    reselleranalytics: '统计分析'
  },
  reseller: {
    // 基础信息
    resellerList: '代理商列表',
    resellerName: '代理商名称',
    resellerLevel: '代理商等级',
    parentReseller: '上级代理商',
    contactPerson: '联系人',
    contactPhone: '联系电话',
    contactEmail: '联系邮箱',
    registrationTime: '注册时间',
    lastLoginTime: '最后登录时间',
    accountStatus: '账户状态',
    totalUsers: '下级用户数',
    totalRevenue: '总营收',
    monthlyRevenue: '本月营收',
    commissionRate: '佣金比例',
    actions: '操作',
    
    // 新增字段
    username: '用户名',
    companyName: '公司名称',
    contactName: '联系人姓名',
    accountAmount: '账户余额',
    apiInfo: 'API信息',
    apiKey: 'API Key',
    secretKey: 'Secret Key',
    notifyUrl: '回调地址',
    status: '状态',
    isSuper: '超管',
    remark: '备注',
    createTime: '创建时间',
    updateTime: '更新时间',
    keyword: '关键词',
    resellerId: '代理商ID',
    yes: '是',
    no: '否',
    viewApiInfo: '查看API信息',
    resellerIdPlaceholder: '请输入代理商ID',
    
    // 占位符文本
    keywordPlaceholder: '用户名、公司名称或联系人姓名',
    usernameRequired: '请输入用户名',
    companyNamePlaceholder: '请输入公司名称',
    contactNamePlaceholder: '请输入联系人姓名',
    contactPhonePlaceholder: '请输入联系电话',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    passwordPlaceholderEdit: '留空则不修改密码',
    passwordRequired: '请输入密码',
    
    remarkPlaceholder: '请输入备注',
    
    // 状态
    active: '正常',
    inactive: '禁用',
    pending: '待审核',
    enabled: '启用',
    disabled: '禁用',
    
    // 等级
    primary: '一级代理商',
    secondary: '二级代理商',
    tertiary: '三级代理商',
    
    // 操作
    viewDetails: '查看详情',
    editReseller: '编辑代理商',
    disableReseller: '禁用代理商',
    enableReseller: '启用代理商',
    deleteReseller: '删除代理商',
    addReseller: '新增代理商',
    recharge: '充值',
    
    // 表单验证
    resellerNameRequired: '请输入代理商名称',
    contactPersonRequired: '请输入联系人',
    contactPhoneRequired: '请输入联系电话',
    contactEmailRequired: '请输入联系邮箱',
    commissionRateRequired: '请输入佣金比例',
    passwordLengthLimit: '密码长度不能少于6个字符',
    
    // 统计分析
    analytics: '统计分析',
    revenueAnalytics: '营收分析',
    userGrowth: '用户增长',
    orderAnalytics: '订单分析',
    topResellers: '优秀代理商',
    revenueChart: '营收趋势图',
    userGrowthChart: '用户增长图',
    orderChart: '订单统计图',
    
    // 时间范围
    today: '今日',
    thisWeek: '本周',
    thisMonth: '本月',
    thisYear: '本年',
    
    // 统计数据
    totalResellerCount: '代理商总数',
    activeResellerCount: '活跃代理商',
    newResellerCount: '新增代理商',
    totalCommission: '总佣金',
    
    // 操作确认
    deleteConfirm: '确定要删除该代理商吗？',
    disableConfirm: '确定要禁用该代理商吗？',
    enableConfirm: '确定要启用该代理商吗？',
    confirmStatusChange: '确定要{action}该代理商吗？',
    superAdminStatusCannotChange: '超级管理员状态不可修改',
    enable: '启用',
    disable: '禁用',
    rechargeInDevelopment: '充值功能开发中...',
    operationSuccess: '操作成功',
    operationFailed: '操作失败',
    getResellerListFailed: '获取代理商列表失败',
    getResellerInfoFailed: '获取代理商信息失败',
    getAnalyticsDataFailed: '获取统计数据失败',
    
    // 充值相关
    rechargeTitle: '代理商充值',
    rechargeAmount: '充值金额',
    rechargeAmountPlaceholder: '请输入充值金额',
    rechargeRemark: '备注信息',
    rechargeRemarkPlaceholder: '请输入备注信息（可选）',
    rechargeAmountRequired: '请输入充值金额',
    rechargeAmountMin: '充值金额不能少于¥1',
    rechargeAmountInvalid: '请输入有效的金额',
    rechargeAmountDecimal: '金额最多支持2位小数',
    rechargeRemarkRequired: '请输入备注信息',
    rechargeSuccess: '充值成功',
    rechargeFailed: '充值失败',
    confirmRecharge: '确认充值¥{amount}给代理商【{username}】？'
  },
  user: {
    username: '用户名',
    email: '邮箱',
    status: '状态',
    isReseller: '是否代理商',
    yes: '是',
    no: '否',
    actions: '操作',
    usernamePlaceholder: '请输入用户名',
    statusPlaceholder: '请选择状态',
    statusAll: '全部',
    statusActive: '启用',
    statusDisabled: '禁用',
    createTime: '创建时间',
    updateTime: '更新时间',
    lastLoginTime: '最后登录时间',
    usernameRequired: '请输入用户名',
    usernameLengthLimit: '用户名长度应在3-20个字符之间',
    passwordRequired: '请输入密码',
    passwordLengthLimit: '密码长度不能少于6个字符',
    remark: '备注',
    addUser: '新增用户',
    password: '密码',
    confirmStatusChange: '确认{action}该用户?',
    enable: '启用',
    disable: '禁用',
    tip: '提示',
    statusChangeSuccess: '{action}成功',
    statusChangeFailed: '{action}失败',
    statusUpdateFailed: '状态更新失败',
    submitSuccess: '提交成功',
    getUserListFailed: '获取用户列表失败',
    confirmRenewIP: '确认为该IP续期?',
    renewSuccess: '续期成功'
  },
  
  // 代理管理页面
  proxyStatic: {
    // 标签页
    purchase: '购买',
    purchased: '已购IP列表',
    renewalRecord: '续期记录',
    
    // 购买表单
    selectPackage: '选择套餐',
    selectRegion: '选择地区',
    deliveryProtocol: '交付协议',
    pleaseSelectRegion: '请选择地区',
    quantity: '数量：',
    calculating: '计算中...',
    paymentAmount: '支付金额：',
    includeExtraFee: '含额外费用',
    payNow: '立即支付',
    reset: '重置',
    
    // 服务特点
    highSpeedStable: '高速稳定，99.9%在线率保证',
    globalCoverage: '全球覆盖，支持200+国家和地区',
    unlimitedBandwidth: '无限带宽，不限制并发连接数',
    professionalSupport: '专业技术支持，7x24小时在线服务',
    
    // 专业特点
    realUserSimulation: '真实用户模拟',
    realUserSimulationDesc: '更难被网站识别为代理，提高隐蔽性',
    highAnonymity: '高匿名性',
    highAnonymityDesc: '减少了被监测和封锁的风险',
    lowBlockRate: '低封锁率',
    lowBlockRateDesc: '使用IP时被网站封锁的概率较低',
    highAuthenticity: '高真实性',
    highAuthenticityDesc: '更难被网站识别为代理，提高隐蔽性',
    betterStability: '更好的稳定性',
    betterStabilityDesc: '更难被网站识别为代理，提高隐蔽性',
    
    // 订单确认
    confirmOrderInfo: '确认订单信息',
    packageInfo: '套餐信息',
    region: '地区',
    protocol: '协议',
    tag: '标签',
    pleaseEnterTag: '请输入标签（可选）',
    maxCharacters: '最多20个字符',
    paymentMethod: '支付方式',
    
    // 订单号
    orderNumber: '订单号',
    isReseller: '是否代理商',
    orderTime: '下单时间',
    
    // IP状态标签
    activeIPs: '活跃IP',
    expiringIPs: '即将过期IP',
    expiredIPs: '已过期IP',
    daysToExpire: '天后到期',
    
    // 搜索表单
    enterIPAddress: '输入IP地址',
    addIP: '+ 添加IP',
    pleaseEnterOrderNo: '请输入订单号',
    pleaseEnterOrderNumber: '请输入订单号',
    collapse: '收起',
    expand: '展开',
    pleaseEnterTag: '请输入标签',
    all: '全部',
    yes: '是',
    no: '否',
    startDate: '开始日期',
    endDate: '结束日期',
    to: '至',
    pleaseEnterResellerID: '请输入代理商ID',
      pleaseEnterUserID: '请输入用户ID',
    enableStatus: '启用状态',
    pleaseSelect: '请选择',
    enabled: '启用',
    disabled: '禁用',
    onlineStatus: '在线状态',
    search: '搜索',
    export: '导出',
    
    // 续期记录搜索
    userID: '用户ID',
    renewalStatus: '续期状态',
    success: '成功',
    failed: '失败',
    renewalTime: '续期时间',
    
    // 支付确认
    confirmPayment: '确认支付',
    confirmPaymentMessage: '确认支付 ¥{amount} 购买代理服务？',
    confirm: '确认',
    cancel: '取消',
    paymentSuccess: '支付成功！订单号：{orderNo}',
    paymentFailed: '支付失败',
    paymentFailedRetry: '支付失败，请重试',
    
    // 表格列名
    renewalResult: '续期结果',
    totalTraffic: '总流量',
    usedTraffic: '已用流量',
    enableStatus: '启用状态',
    
    // 通用
    none: '无',
    
    // 错误提示
    priceCalculationFailed: '价格计算失败',
    getPackageListFailed: '获取套餐列表失败',
    getRegionListFailed: '获取地区列表失败',
    getProxyListFailed: '获取代理列表失败',
    getRenewalListFailed: '获取续期记录失败',
    pleaseEnterValidIPFormat: '请输入有效的IP地址格式',
    proxyInfoCopied: '代理信息已复制到剪贴板',
    getProxyInfoFailed: '获取代理信息失败',
    copyProxyInfoFailed: '复制代理信息失败',
    networkError: '网络错误',
    copyFailedManualCopy: '复制失败，请手动复制',
    renewalSuccess: '续期成功',
    renewalFailed: '续期失败',
    preparingExport: '正在准备导出文件...',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    pleaseSelectPackage: '请选择套餐',
    pleaseEnterQuantity: '请输入数量',
    pleaseSelectPaymentMethod: '请选择支付方式',
    balancePayment: '余额支付',
    alipay: '支付宝',
    wechatPay: '微信支付',
    confirmRenewProxy: '确定要续期该代理吗？',
     pleaseSelectRecords: '请选择要导出的记录',
     
     // 批量修改标签
     batchUpdateTag: '批量修改标签',
     newTag: '新标签',
     pleaseEnterNewTag: '请输入新标签',
     selectedRecordsCount: '已选择 {count} 条记录',
     batchUpdateTagSuccess: '批量修改标签成功',
     batchUpdateTagFailed: '批量修改标签失败',
     
     // 批量刷新代理信息
     batchSyncProxyInfo: '批量刷新代理信息',
     pleaseSelectRecordsForSync: '请选择要刷新代理信息的记录',
     pleaseSelectRecordsForTag: '请选择要修改标签的记录',
     
     // 批量复制代理
     batchCopyProxy: '批量复制代理',
     pleaseSelectRecordsForCopy: '请选择要复制的记录',
    batchCopySuccess: '已成功复制 {count} 个代理信息到剪贴板',
      getBatchProxyInfoFailed: '获取批量代理信息失败',
      batchCopyProxyFailed: '批量复制代理失败',
     
     // 新增列
     hostname: '主机',
     accountName: '用户名',
     password: '密码',
     
     // 复制功能
     hostnameCopied: '主机已复制到剪贴板',
     accountNameCopied: '用户名已复制到剪贴板',
     passwordCopied: '密码已复制到剪贴板',
     copyFailed: '复制失败',
     
     // 同步IP功能
     syncIP: '同步IP',
     systemAccount: '系统账号',
      resellerID: '代理商ID',
      userID: '用户ID',
     proxyType: '代理类型',
     ipLocation: 'IP归属地',
     productType: '产品类型',
     days: '天数',
     channel: '通道',
     deductBalance: '是否扣余额',
     unitPrice: '单价',
     tag: '标签',
     remark: '备注',
     syncExcel: '待同步Excel',
     uploadExcel: '上传Excel文档',
     excelTips: '文档标题需确保有字段"主机，IP地址，端口，账号，密码，代理ID，线路ID，过期时间"，其中主机和线路ID的值没有的话可以留空',
     pleaseSelectSystemAccount: '请选择系统账号',
     pleaseEnterUserID: '请输入用户ID',
     pleaseSelectIPLocation: '请选择IP归属地',
     pleaseSelectProductType: '请选择产品类型',
     pleaseSelectDays: '请选择天数',
     pleaseSelectChannel: '请选择通道',
     pleaseSelectDeductBalance: '请选择是否扣余额',
     pleaseEnterUnitPrice: '请输入单价',
     unitPriceMustGreaterThanZero: '单价必须大于0',
     pleaseUploadExcel: '请上传Excel文档',
     onlyExcelAllowed: '只能上传Excel文件',
     fileSizeLimit: '文件大小不能超过10MB',
     submitSync: '提交同步',
     resetForm: '重置表单',
     syncSuccess: '同步成功',
     syncFailed: '同步失败',
     getCountryListFailed: '获取国家列表失败',
     getProductListFailed: '获取产品列表失败',
     gk: 'GK',
     other: '其他',
     thirtyDays: '30天',
     sixtyDays: '60天',
     ninetyDays: '90天',
     
     // 同步IP功能
     syncIP: '同步IP',
     syncIPForm: '同步IP表单',
     systemAccount: '系统账号',
     pleaseSelectSystemAccount: '请选择系统账号',
     pleaseSelectLocation: '请选择IP归属地',
     productType: '产品类型',
     pleaseSelectProduct: '请选择产品类型',
     pleaseSelectDays: '请选择天数',
     zone: '通道',
     pleaseSelectZone: '请选择通道',
     unitPrice: '单价',
     pleaseEnterUnitPrice: '请输入单价',
     isDeductBalance: '是否扣余额',
     pleaseSelectDeductBalance: '请选择是否扣余额',
     remark: '备注',
     pleaseEnterRemark: '请输入备注',
     syncExcel: '待同步Excel',
     selectFile: '选择文件',
     excelTip: '只能上传xlsx/xls文件，且不超过10MB',
     excelRequirementTip: '注意：Excel文档的标题行请确保包含"主机"、"IP地址"、"账号"、"密码"、"端口"、"代理ID"、"线路ID"、"过期时间"等字段（字段名必须是简体中文）',
     submitSync: '提交同步',
     onlyExcelAllowed: '只能上传Excel文件',
     fileSizeLimit: '文件大小不能超过10MB',
     pleaseSelectFile: '请选择文件'
   },
  error: {
    '404': '抱歉，您访问的页面不存在',
    '403': '抱歉，您没有权限访问此页面',
    back: '返回上页',
    home: '回到首页'
  }
}
